const fixedOutfitImgScroll = () => {
  var productDescWrapperHeight = null;
  $("#product-desc-wrapper").bind('resize', function() {
    if ($("#product-desc-wrapper").height() != productDescWrapperHeight) {
      productDescWrapperHeight = $("#product-desc-wrapper").height();
      fixedOutfitImg();
    }
  });
}

const fixedOutfitImg = () => {
  if (Modernizr.csspositionsticky) {
    $('.col-mainImgWrapper').css({
        'position': 'sticky',
        'position': '-webkit-sticky',
        'top': '75px',
        'min-height': '450px',
        'padding-bottom': '30px !important'
    });
  }

  if (!Modernizr.csspositionsticky) {

    if ($('.outfit-display-page').length > 0 && $('.bundle-display-page').length > 0 && $('.col-mainImgWrapper .espot a img').length == 0) {
      //No Espots
        var div = $('#product-desc-wrapper');
        var x = div.height() + 70;
        var productImage = $('#productImageContain').height() + 70;
        var bottom = x - productImage;
        var imgContainerHeight = $('.col-mainImgWrapper').parent().height() + "px";
        var mainImageWidth = $('.mainImage').width();

        $(window).scroll(function() {
            var scroll = $(document).scrollTop();
            $('.col-mainImgWrapper').css({
                'height': imgContainerHeight,
                'position': 'relative',
            });

            if (scroll >= 155 && scroll <= bottom) {
            $('#productImageContain').css({
                'position': 'fixed',
                'width': mainImageWidth,
                'max-height': productImage,
                'top': '80px',
                'z-index': '16',
            });
            $('#alt-image-container').css({
                'top': '0px',
            });
        } else if (scroll >= bottom) {
            $('#productImageContain').css({
                'position': 'absolute',
                'width': mainImageWidth,
                'max-height': productImage,
                'bottom': '0px',
                'top': 'inherit',
                'z-index': '16',
            });
            $('#alt-image-container').css({
                'top': '-170px',
            });
        } else {
            $('#productImageContain').css({
                'position': 'absolute',
                'width': mainImageWidth,
                'max-height': productImage,
                'top': '0px',
                'z-index': '16',
            });
            $('#alt-image-container').css({
                'top': '0px',
            });
        }

        });
    }

    if ($('.outfit-display-page').length > 0 && $('.bundle-display-page').length > 0 && $('.col-mainImgWrapper .espot a img').length > 0) {
      //Has Espots
        var div = $('#product-desc-wrapper');
        var x = div.height() + 70;
        var productImage = $('#productImageContain').height();
        var imgContainerHeight = $('.col-mainImgWrapper').parent().height() + "px";
        var mainImageWidth = $('.mainProductImage').width() + 40 + 'px';
        var espotTop = (productImage + 70) + "px";
        var espotHeight1 = $('#espot1').height() + 10;
        var espotHeight2 = $('#espot2').height() + 10;
        var espotHeight = espotHeight1 + espotHeight2;
        var espotTop2 = (productImage + espotHeight1 + 80) + "px";
        var espotWidth = ($('#productImageContain').width()) + 40 + "px";
        var bottom = x - productImage - espotHeight - 20;

        var collections = $('.collection-list .slick-list').length;

        $(window).scroll(function() {
            var scroll = $(document).scrollTop();
            $('.col-mainImgWrapper').css({
                'height': imgContainerHeight,
                'position': 'relative',
            });

                if (scroll >= 155 && scroll <= bottom) {
                    $('#espot1').css({
                        'position': 'fixed',
                        'top': espotTop,
                        'max-width': espotWidth,
                    });
                    $('#espot2').css({
                        'position': 'fixed',
                        'top': espotTop2,
                        'max-width': espotWidth,
                    });
                    $('#productImageContain').css({
                        'position': 'fixed',
                        'width': mainImageWidth,
                        'max-height': productImage,
                        'top': '70px',
                        'z-index': '16',
                    });
                } else if (scroll >= bottom) {
                    $('#productImageContain').css({
                        'position': 'absolute',
                        'width': mainImageWidth,
                        'max-height': productImage,
                        'bottom': espotHeight,
                        'top': 'inherit',
                        'z-index': '16',
                    });
                    $('#espot1').css({
                        'position': 'absolute',
                        'bottom':  espotHeight2,
                        'top': 'inherit',
                        'max-width': espotWidth,
                    });
                    $('#espot2').css({
                        'position': 'absolute',
                        'bottom': '0px',
                        'top': 'inherit',
                        'max-width': espotWidth,
                    });
                } else {
                    $('#espot1').css({
                        'position': 'absolute',
                        'top': productImage,
                        'max-width': espotWidth,
                    });
                    $('#espot2').css({
                        'position': 'absolute',
                        'top': espotTop2,
                        'max-width': espotWidth,
                    });
                    $('#productImageContain').css({
                        'position': 'absolute',
                        'width': mainImageWidth,
                        'max-height': productImage,
                        'top': '0px',
                        'z-index': '16',
                    });
                }

        });
    }
  }
};

export {
  fixedOutfitImg,
  fixedOutfitImgScroll
}
